import { render, staticRenderFns } from "./mxfsq.vue?vue&type=template&id=0005c07f"
import script from "./mxfsq.vue?vue&type=script&lang=js"
export * from "./mxfsq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports